export interface ApiConfiguration {
  baseUrl: string
}

const baseUrlEnv: string = typeof import.meta.env.VITE_API_BASE_URL === 'string'
  ? import.meta.env.VITE_API_BASE_URL
  : ''

// Determine base URL:
//   - If VITE_API_BASE_URL is set, use it verbatim.
//   - Otherwise: empty string, i.e. same-origin relative URLs.
//
// In every realistic deployment of the three-apps split the SPA and its API
// share an origin:
//   - dev (Vite at :3001/:3002/:3003): vite.config.ts proxies /api to the
//     matching per-app backend port (7010/7020/7030).
//   - local-prod-style (`deploy/start-<slug>.sh` or systemd on :7010/:7020/
//     :7030): the per-app API host serves both the SPA dist and /api.
//   - prod (concrete./wood./steel.structuramatrix.no): nginx terminates TLS
//     and reverse-proxies the matching localhost port; SPA and /api share
//     the subdomain.
// A literal http://localhost:7000 fallback (the old monolith port) would
// break each of these, so there is no such fallback.
const getBaseUrl = (): string => {
  const trimmed: string = baseUrlEnv.trim()
  if (trimmed.length > 0) {
    return trimmed.replace(/\/?$/, '')
  }
  return ''
}

export const apiConfig: ApiConfiguration = {
  baseUrl: getBaseUrl()
}
